import script from "./CalculoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CalculoPage.vue?vue&type=script&setup=true&lang=js"

import "./CalculoPage.vue?vue&type=style&index=0&id=5e9d1d31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e9d1d31"]])

export default __exports__